<div class="td-wb-w8ben-form-container">
  <td-wb-modal-header id="td-wb-w8ben-form-header"
                      class="td-wb-w8ben-form-container__header"
                      iconId="logo--td">
    <td-wb-modal-header-buttons>
      <td-wb-modal-close-button buttonBackground="clear-grey"
                                [autoFocus]="false" />
    </td-wb-modal-header-buttons>
  </td-wb-modal-header>

  <div class="td-wb-w8ben-form-container__content"
       ui-view="w8ben-content"></div>
</div>

<ng-template #confirmTemplate>
  <td-wb-confirm>
    <td-wb-confirm-title>
      <span [attr.id]="'td-wb-w8ben-container-dismiss-dialog' + '-title'"
            translate="tdWb.w8BenForm.modal.dismissDialog.TITLE"></span>
    </td-wb-confirm-title>
    <td-wb-confirm-body>
      <span translate="tdWb.w8BenForm.modal.dismissDialog.DESCRIPTION"></span>
    </td-wb-confirm-body>
    <td-wb-confirm-buttons>
      <td-wb-confirm-button-cancel>
        <span translate="tdWb.w8BenForm.modal.dismissDialog.BACK_BUTTON"></span>
      </td-wb-confirm-button-cancel>
      <td-wb-confirm-button-ok>
        <span translate="tdWb.w8BenForm.modal.dismissDialog.CONFIRM_BUTTON"></span>
      </td-wb-confirm-button-ok>
    </td-wb-confirm-buttons>
  </td-wb-confirm>
</ng-template>
